<template>
  <div id="app-layout">
    <v-app>
      <m-header />

      <v-main class="vertical-stretch1">
        <v-row no-gutters>
          <v-col 
            v-if="userRoles"
            cols="auto"
          >
            <div id="left-navbar">
              <LeftNavDrawer />
            </div>
          </v-col>
          <v-col
            class="vertical-stretch page-section"
            id="scroll-layout-section"
          >
            <div id="page-section" class="width-100">
              <v-container fluid class="px-8 position-relative">
                <router-view />
                <v-navigation-drawer
                  v-if="$store.state.ui.drawer.right.show"
                  v-model="$store.state.ui.drawer.right.show"
                  fixed
                  temporary
                  right
                  :width="$store.state.ui.drawer.right.width || '500px'"
                  class="header-stretch"
                >
                  <component :is="$store.state.ui.drawer.right.component" />
                </v-navigation-drawer>
              </v-container>
            </div>
          </v-col>
        </v-row>
        <GlobalSnackbar> </GlobalSnackbar>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import { DashboardComponents } from '@core/components'
import LeftNavDrawer from '@/components/shared/LeftNavDrawer';
import GlobalSnackbar from "@/components/ui/GlobalSnackbar";
import { mapGetters } from 'vuex'

export default {
  name: "AppLayout",
  components: {
    ...DashboardComponents,
    LeftNavDrawer,
    GlobalSnackbar,
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
        account: 'auth/account',
        userAccess: 'auth/userAccess'}),
    userRoles() {
        if(this.account.current)
          return (this.account.current.enable_service && this.userAccess.haveServiceRole)
    }
  },
  methods: {},
};
</script>
